import { render, staticRenderFns } from "./caringPlatform.vue?vue&type=template&id=7104be7d&scoped=true"
import script from "./caringPlatform.vue?vue&type=script&lang=js"
export * from "./caringPlatform.vue?vue&type=script&lang=js"
import style0 from "./caringPlatform.vue?vue&type=style&index=0&id=7104be7d&prod&scoped=true&lang=css"
import style1 from "./caringPlatform.vue?vue&type=style&index=1&id=7104be7d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104be7d",
  null
  
)

export default component.exports